import { useTranslation } from 'react-i18next';

import {
    IconPaid,
    IconSavings,
    NavLink,
} from '@myphx-engineering/phx-design-system';

import {
    type PatientSavingsRecommendationInfoFragment,
    type PlanSavingsRecommendationInfoFragment,
    RecommendationKind,
} from '../../../graphql/generated/graphql';
import { formatToLocalizedCurrency } from '../../../util';

type RecommendationsLinkProps = {
    onAltsClick: () => void;
    recommendations:
        | (
              | PatientSavingsRecommendationInfoFragment
              | PlanSavingsRecommendationInfoFragment
          )[]
        | undefined;
};

export const RecommendationsLink = (props: RecommendationsLinkProps) => {
    const { onAltsClick, recommendations } = props;
    const { t } = useTranslation();

    const newProducts = [];
    let bestPatientSavings = 0;
    let bestPlanSavings = 0;
    recommendations?.forEach((recommendation) => {
        if (
            recommendation.kind ===
                RecommendationKind.AlternativePatientSavings &&
            recommendation.savings > bestPatientSavings
        ) {
            bestPatientSavings = recommendation.savings;
        } else if (
            recommendation.kind === RecommendationKind.AlternativePlanSavings &&
            recommendation.savings > bestPlanSavings
        ) {
            bestPlanSavings = recommendation.savings;
        }
        newProducts.push(recommendation);
    });

    const lowPatientSavings = bestPatientSavings <= 1;
    const planSavingsThreshold = 20;

    if (
        recommendations?.length === 0 ||
        (lowPatientSavings && bestPlanSavings < planSavingsThreshold)
    ) {
        return null;
    }

    const savePlanWithAlternative =
        lowPatientSavings && bestPlanSavings >= planSavingsThreshold;

    const { savingsText, Icon } = savePlanWithAlternative
        ? {
              savingsText: t('pickYourPharmacy.altPlanSavings', {
                  value: formatToLocalizedCurrency(bestPlanSavings, {
                      maximumFractionDigits: 0,
                  }),
              }),
              Icon: IconPaid,
          }
        : {
              savingsText: t('pickYourPharmacy.altSavings', {
                  value: formatToLocalizedCurrency(bestPatientSavings, {
                      maximumFractionDigits: 0,
                  }),
              }),
              Icon: IconSavings,
          };
    return (
        <NavLink
            active
            label={savingsText}
            color={savePlanWithAlternative ? 'info' : 'saving'}
            variant="light"
            Icon={Icon}
            onClick={onAltsClick}
        />
    );
};
